import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="inicio" className="relative w-full min-h-screen flex flex-col items-center pt-8 pb-12 px-4 overflow-hidden bg-transparent" data-id="element-228">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gradPurple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-229" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center z-10" data-id="element-230">
        <motion.div initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} className="flex flex-col items-center w-full" data-id="element-231">
          {/* Pre-title Badge */}
          <motion.div variants={itemVariants} className="mb-3" data-id="element-232">
            <span className="bg-gradOrange text-white text-xs md:text-sm font-bold px-4 py-1.5 rounded-full shadow-[0_0_15px_rgba(255,107,0,0.3)]" data-id="element-233">
              🎓 Para estudiantes universitarios
            </span>
          </motion.div>

          {/* Main Title */}
          <motion.h1 variants={itemVariants} className="text-[22px] md:text-4xl lg:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-234">
            Resolvé tu cursada
            <br data-id="element-235" />
            hoy.
            <br data-id="element-236" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gradOrange via-gradPink to-gradPurple italic" data-id="element-237">
              Sin estrés
            </span>
          </motion.h1>

          {/* Image */}
          <motion.div variants={itemVariants} className="relative w-full max-w-[420px] mx-auto mb-2 -mt-4 md:-mt-6" data-id="element-238">
            <img src="https://cdn.magicpatterns.com/uploads/qYjTtQzWbqAYbxUtBdsg6K/75bef076-d4a6-4099-9703-21a51715b120.png" alt="MegaPack Universitario Cursada Sin Estrés" className="w-[50%] mx-auto h-auto object-contain drop-shadow-[0_0_50px_rgba(138,43,226,0.2)] mt-[-30px] mb-[-30px]" data-id="element-239" />
          </motion.div>

          {/* Lower CTA Area */}
          <motion.div variants={itemVariants} className="flex flex-col items-center w-full max-w-3xl relative" data-id="element-240">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-241">
              <div className="border border-gradOrange/50 text-gradOrange px-4 py-1.5 rounded-full font-bold text-xs md:text-sm tracking-widest bg-gradOrange/10" data-id="element-242">
                EDICIÓN COMPLETA 2026
              </div>
              <div className="bg-gradOrange text-white font-black w-14 h-14 rounded-full flex items-center justify-center text-center shadow-[0_0_20px_rgba(255,107,0,0.5)] text-[11px] leading-tight" data-id="element-243">
                50%
                <br data-id="element-244" />
                OFF
              </div>
            </div>

            <p className="text-base md:text-lg text-white font-medium mb-6 max-w-2xl leading-relaxed" data-id="element-245">
              Organizá tus materias, parciales y entregas desde el primer día.
              <br data-id="element-246" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gradOrange via-gradPink to-gradPurple font-black text-lg md:text-xl" data-id="element-247">
                Sin improvisar. Sin colapsar.
              </span>
            </p>

            <a href="#elegir-opcion" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black text-lg md:text-2xl px-6 md:px-8 py-3 rounded-full transition-all duration-300 mb-5 w-full md:w-auto inline-block text-center no-underline hover:scale-105 shadow-[0_0_15px_rgba(16,185,129,0.3)]" data-id="element-248">
              Quiero el MegaPack Universitario
            </a>

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-medium text-textMuted" data-id="element-249">
              <span className="flex items-center gap-2" data-id="element-250">
                <span className="text-white/50" data-id="element-251">📄</span> 100% PDF
              </span>
              <span className="flex items-center gap-2" data-id="element-252">
                <span className="text-white/50" data-id="element-253">⚡</span> Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-254">
                <span className="text-white/50" data-id="element-255">🛡️</span> Garantía 7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-256">
                <span className="text-white/50" data-id="element-257">💳</span> Mercado Pago
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}